interface ChipContentProps {
  content: string;
}

export default function ChipContent({ content }: ChipContentProps): JSX.Element {
  return <span>{content}</span>;
}
